var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 2.66797V17.3346M29.3334 13.068V6.93464C29.3334 5.44116 29.3334 4.69443 29.0427 4.12399C28.7871 3.62223 28.3791 3.21428 27.8773 2.95862C27.3069 2.66797 26.5602 2.66797 25.0667 2.66797H10.824C8.8754 2.66797 7.90108 2.66797 7.11414 3.02455C6.42056 3.33882 5.8311 3.84453 5.41502 4.48226C4.94292 5.20583 4.79477 6.16882 4.49847 8.0948L3.80103 12.6281C3.41022 15.1684 3.21482 16.4385 3.59177 17.4268C3.92262 18.2942 4.54489 19.0196 5.35193 19.4785C6.27141 20.0013 7.55647 20.0013 10.1266 20.0013H11.2C11.9468 20.0013 12.3201 20.0013 12.6054 20.1466C12.8562 20.2745 13.0602 20.4784 13.188 20.7293C13.3334 21.0145 13.3334 21.3879 13.3334 22.1346V26.0469C13.3334 27.8626 14.8054 29.3346 16.6211 29.3346C17.0542 29.3346 17.4467 29.0796 17.6226 28.6838L22.1036 18.6015C22.3074 18.143 22.4093 17.9137 22.5704 17.7456C22.7128 17.5969 22.8877 17.4833 23.0813 17.4136C23.3004 17.3346 23.5513 17.3346 24.0531 17.3346H25.0667C26.5602 17.3346 27.3069 17.3346 27.8773 17.044C28.3791 16.7883 28.7871 16.3804 29.0427 15.8786C29.3334 15.3082 29.3334 14.5614 29.3334 13.068Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.482601b9c6308a0d4b463f3b7afd91c6.svg";
export { ForwardRef as ReactComponent };